import { useCallback } from 'react'

import { config } from 'app/config'

import { httpCall } from './httpUtils'

const apiPath = '/api'

const useHttp = () => {
  const httpDelete = useCallback(
    <E>(endpoint: string) =>
      httpCall<never, undefined, E>(`${config.innkeeprBaseApiUrl}${apiPath}${endpoint}`, 'DELETE'),
    [],
  )

  const httpGet = useCallback(
    <R, E>(endpoint: string) =>
      httpCall<never, R, E>(`${config.innkeeprBaseApiUrl}${apiPath}${endpoint}`),
    [],
  )

  const httpPatch = useCallback(
    <T, R, E>(endpoint: string, data: T, contentType = 'application/json') =>
      httpCall<T, R, E>(
        `${config.innkeeprBaseApiUrl}${apiPath}${endpoint}`,
        'PATCH',
        contentType,
        data,
      ),
    [],
  )

  const httpPost = useCallback(
    <T, R, E>(endpoint: string, data: T, contentType = 'application/json') =>
      httpCall<T, R, E>(
        `${config.innkeeprBaseApiUrl}${apiPath}${endpoint}`,
        'POST',
        contentType,
        data,
      ),
    [],
  )

  const httpPut = useCallback(
    <T, R, E>(endpoint: string, data: T, contentType = 'application/json') =>
      httpCall<T, R, E>(
        `${config.innkeeprBaseApiUrl}${apiPath}${endpoint}`,
        'PUT',
        contentType,
        data,
      ),
    [],
  )

  return {
    httpDelete,
    httpGet,
    httpPatch,
    httpPost,
    httpPut,
  }
}

export default useHttp
